<template>
  <div ref="chart" class="chart-container"></div>
<!--  <div id="echarts2" style="width: 50px;height:50px;"></div>-->
</template>

<script>
import * as echarts from 'echarts';


export default {
  name: 'SimpleLineChart',
  mounted() {
    this.renderChart();
  },
  props: ['message','color'],
  watch: {
    message: {
      handler(newValue, oldValue) {
        this.renderChart(); // 数据变化时重新渲染图表
      },
      deep: true // 深度监听，可以监听对象和数组的变化
    }
  },
  methods: {
    renderChart() {
      const chart = echarts.init(this.$refs.chart);
      const numbers = this.message.split(',').map(Number)
      numbers.pop();
      const minValue = Math.min(...numbers) - 1;
      const maxValue = Math.max(...numbers) + 1;
      const options = {
        xAxis: {
          type: 'category',
          data:Array.from({length: numbers.length}, (_, i) => i + 1),
          // data: [820.2, 932.3, 901.5, 934.2, 1290, 1330, 1320,820.2, 932.3, 901.5, 934.2, 1290, 1330, 1320],
          show:false
        },
        yAxis: {
          type: 'value',
          show: false, // 不显示 y 轴
          min: minValue, // 手动设置最小值，略低于数据的最小值
          max: maxValue,
        },
        series: [
          {
            // data: this.message.split(',').map(Number),
            data:numbers,
            type: 'line',
            showSymbol: false,
            smooth: false,
            clipOverflow: true,  // 确保超出部分被剪裁
            lineStyle: {
              color: this.color, // 修改折线的颜色，使用十六进制颜色值
              type: 'solid'      // 实线，可以改为 'dashed' 或 'dotted' 以改变线条类型
            },
          }
        ]
      };
      chart.setOption(options);
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100px;
  height: 40px;
  margin: 0 auto; /* 让图表居中 */
}
</style>
